import { CHIP_DENOMINATIONS, chipBreakdown, formatUSD, type Cents } from "../src/engine/money.ts";

/** Renders up to 3 stacks of chips (largest denominations first) as HTML. */
export function chipStackHTML(amount: Cents, maxStacks = 3, maxHeight = 6): string {
  if (amount <= 0) return "";
  const stacks = chipBreakdown(amount).slice(0, maxStacks);
  // If the amount needs more denominations than we show, the label still carries the exact value.
  return (
    `<div class="chips">` +
    stacks
      .map((s) => {
        const n = Math.min(s.count, maxHeight);
        const chips = Array.from({ length: n }, (_, i) => `<i class="chip ${s.color}"></i>`).join("");
        return `<span class="stack">${chips}</span>`;
      })
      .join("") +
    `</div>`
  );
}

export const money = (c: Cents): string => formatUSD(c);

/** `$12` for whole dollars, `$12.50` otherwise. Compact form for tight spaces. */
export function moneyShort(c: Cents): string {
  return c % 100 === 0 ? `$${(c / 100).toLocaleString("en-US")}` : formatUSD(c);
}

export { CHIP_DENOMINATIONS };
